
import TripDetailsContainer from "./TripDetailsContainer";
import TripDteailsStore from "./TripDteailsStore";

export default TripDteailsStore(TripDetailsContainer); 
